import ng from 'angular';
import { StaffConst } from '@/configuration';
import { AuthContextService, GetEntryPointService } from '@/services';

import './supporter-block.scss';

export class MoleculeSupporterBlockController implements ng.IController {
    public static $inject: string[] = ['getEntryPoint', '$translate'];

    public backgroundSize: 'sm';
    public supportPhone: string = AuthContextService.accountOrganizationInformation.companyPhoneNumber;
    public supportPhoneMin ='';
    public supportMail: string = AuthContextService.accountOrganizationInformation.companyEmailAddress;
    public staff: {name: string; title: string} = {
        name: StaffConst.kahrs.name,
        title: StaffConst.kahrs.title
    };

    constructor(
        private getEntryPointService: GetEntryPointService,
        private $translate: ng.translate.ITranslateService,
    ) {
    }

    // Call getEntryPoint
    public $onInit(): void {
        this.supportPhoneMin = this.supportPhone.replace(/([() _-])/ig, '');
    }

    public get openingTimes(): string {
        return this.$translate.instant(
            'TR_130525-ae2a9d_TR',
            {
                startTime: this.getEntryPointService.supportStartTime,
                endTime: this.getEntryPointService.supportEndTime
            }
        );
    }
}

export class MoleculeSupporterBlockComponent implements ng.IComponentOptions {
    public bindings = {
        backgroundSize: '@?'
    };
    public controller =  MoleculeSupporterBlockController;
    public template = require('./supporter-block.html');
}
